<!-- <span class="version-footer">
    <span style="color: #00562b; font-size: larger" class="bold"
        >eFAACT</span
    >&nbsp;<span>Version: {{ environment.version }}-{{
        environment.environment
    }}</span>&nbsp;
    <span>API Version: {{ version$ | async }}</span>
</span>
<a style="margin-left: 1em;" href=" https://efaactcentral.com/releasenotes/efaactreleasenotes.htm" target="_blank">Release Notes</a> -->

<!-- <div class="grid">
    <div class="col col-auto xl:col-4 lg:col-12 md:col-12 sm:col-12 xs:col-12">
        <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
            <span class="text-xl text-center font-medium text-90">About</span>
            <div class="p-3">
                <div class="p-4 mb-4 flex justify-content-center">
                    <span class="p-float-label">
                        <input type="text" id="admincount" pInputText [(ngModel)]="eFAACTVersion">
                        <label for="admincount">eFAACT Version</label>
                    </span>
                </div>
                <div class="p-4 mb-4 flex justify-content-center">
                    <span class="p-float-label">
                        <input type="text" id="admincount" pInputText [(ngModel)]="eFAACTApiVersion">
                        <label for="admincount">eFAACT API Version</label>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div> -->

